require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
module.exports = require('../modules/_core').Map;


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/core-js/es6/map.js
// module id = ../../../../core-js/es6/map.js
// module chunks = 1